import { Component, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Globals } from "../../common/global";
import { ApiCallingService } from "../../services/api-calling.service";
import { ConfigApi } from "../../config-api";
import { HttpParams } from "@angular/common/http";
import * as moment from "moment";

@Component({
  selector: "app-vending-coupon",
  templateUrl: "./vending-coupon.component.html",
  styleUrls: ["./vending-coupon.component.css"],
})
export class VendingCouponComponent implements OnInit {
  @ViewChild("specialityform", { static: true }) specialityform: NgForm =
    Object.create(null);
  today: any = moment(new Date()).format("YYYY-MM-DD");

  modeltitle: any;
  page = 1;
  pageSize = 10;
  data = [];
  totalcount = 0;
  detail: any;
  packages = [];
  pattern = /(\w+)$/;
  pId: any;
  constructor(
    private modalService: NgbModal,
    private apiCallingService: ApiCallingService,
    private toastr: ToastrService,
    public Globals: Globals,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.pId = params["pId"];
    });

    this.getList();
  }

  closeBtnClick() {
    this.modalService.dismissAll();
  }
  getList() {
    let operator_id = this.Globals.getUser()._id;
    const pageIndex = this.page > 0 ? this.page - 1 : 0;

    this.apiCallingService
      .callAPI(
        {},
        "GET",
        ConfigApi.URLS.VENDING_COUPON.VENDING_COUPON_LIST +
        `?operator_id=${operator_id}&page=${pageIndex}&limit=${this.pageSize}`
      )
      .subscribe((res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.data = res.data;
          this.totalcount = res.total;
        }
      });
  }
  loadPage(page: number) {
    this.page = page;
    this.getList();
  }

  delete(): void {
    this.apiCallingService
      .callAPI(
        {},
        "DELETE",
        ConfigApi.URLS.VENDING_COUPON.VENDING_COUPON_DELETE +
        "/" +
        this.detail._id
      )
      .subscribe((res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.toastr.success(res.msg);
          this.closeBtnClick();
          this.ngOnInit();
        }
      });
  }

  onSubmit(f: any) {
    const body = new HttpParams()
      .set("operator_id", this.Globals.getUser()._id)
      .set("storeLocationId", this.pId)
      .set("couponCode", f.value.couponCode)
      .set("discountPercent", f.value.discountPercent)
      .set("isMultipleUse", f.value.isMultipleUse)
      .set("expire_date", f.value.expire_date)
      .set("limit", f.value.limit)
      .set("freeShipping", f.value.freeShipping);

    let url = ConfigApi.URLS.VENDING_COUPON.VENDING_COUPON_CREATE;
    let method = "POST";

    console.log("body", body)

    if (this.modeltitle == "Edit Coupon") {
      url =
        ConfigApi.URLS.VENDING_COUPON.VENDING_COUPON_UPDATE +
        "/" +
        this.detail._id;
      method = "PUT";
    }
    this.apiCallingService.callAPI(body, method, url).subscribe(
      (res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.toastr.success(res.msg);
          this.closeBtnClick();
          this.ngOnInit();
        } else {
          this.toastr.error(res.msg);
        }
      },
      (err) => {
        this.toastr.error(err.error.msg, "Error");
      }
    );
  }

  openModal(targetModal: NgbModal, data: any, title: any) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
    this.modeltitle = title;
    this.detail = Object.assign({}, data);
    this.detail.expire_date = moment(
      this.detail.expire_date ?? new Date()
    ).format("YYYY-MM-DD");
    if (Object.keys(data).length == 0) {
      this.detail.isMultipleUse = false;
      this.detail.type = "hour";
      this.detail.time = 1;
      this.detail.freeShipping = false;
    } else {
      this.detail.freeShipping = this.detail.freeShipping ?? false;
    }
  }
}
